<div class="container mt-10 d-flex justify-content-center align-items-center">
  <div class="w-50 mx-auto label">
    <form [formGroup]="isCompany ? signupForm : signupFormMerchant">
      <h3 class="text-center mt-4 title">Créer votre compte {{isCompany ? 'entreprise' : 'commerçant'}}</h3>
      <div class="text-center mb-4">
        Déjà membre ? <a class="a" [routerLink]="link"> Se connecter</a>
      </div>
      
      <!-- Custom Stepper component -->
      <div class="stepper-container mt-20 mb-10 d-flex justify-content-center">
        <div class="stepper-wrapper">
          <!-- Step 1 -->
          <div class="stepper-item" [ngClass]="{'active': currentStep >= 1, 'completed': currentStep > 1}">
            <div class="step-counter">1</div>
            <div class="step-name">Votre {{isCompany ? 'entreprise' : 'commerce'}}</div>
          </div>
          <!-- Connector Line -->
          <div class="stepper-connector"></div>
          <!-- Step 2 -->
          <div class="stepper-item" [ngClass]="{'active': currentStep >= 2}">
            <div class="step-counter">2</div>
            <div class="step-name">Vos informations</div>
          </div>
        </div>
      </div>

      <!-- Step 1: Entreprise, NInea, address, telephone, avantages sociaux -->
      <div *ngIf="currentStep === 1">
        <!-- Champs partagés -->
        <div class="row">
          <div class="col-md-6 mb-4" *ngFor="let field of ['name', 'ninea']">
            <div class="form-outline">
              <label class="form-label" [for]="field">{{ field === 'name' ? (isCompany ? 'Nom Entreprise' : 'Nom Commerçant') : 'Ninea' }}</label>
              <input 
                type="text" 
                [id]="field" 
                class="form-control form-control-lg input"
                [formControlName]="field"
              />
              <div *ngIf="isFieldInvalid(field)" class="text-danger small mt-1">
                Ce champ est requis
              </div>
            </div>
          </div>
        </div>

        <!-- Adresse -->
        <div class="form-outline mb-4">
          <label class="form-label" for="address">Adresse *</label>
          <input 
            type="text" 
            id="address" 
            class="form-control form-control-lg input" 
            formControlName="address"
          />
          <div *ngIf="isFieldInvalid('address')" class="text-danger small mt-1">
            Ce champ est requis
          </div>
        </div>

        <!-- Téléphone -->
        <div class="form-outline mb-4">
          <label class="form-label" for="ownerPhone">Numéro de téléphone *</label>
          <input
            type="tel"
            id="ownerPhone"
            class="form-control form-control-lg input"
            formControlName="ownerPhone"
            placeholder="77 -727- 00 - 11"
          />
          <div *ngIf="isFieldInvalid('ownerPhone')" class="text-danger small mt-1">
            Ce champ est requis
          </div>
        </div>

        <!-- Tickets ou Catégories -->
        <!-- Si c'est une entreprise (checkbox + options) -->
        <div class="row" *ngIf="isCompany">
          <div class="col-md-12 mb-4">
            <label class="fw-bold">Avantages sociaux *</label>
            <div class="row">
              <div class="col-4 input" *ngFor="let option of options">
                <input 
                  type="checkbox" 
                  [value]="option.id"
                  [checked]="option.selected"
                  (change)="onSelectionChange($event, option)" 
                />
                {{ option.label }}
              </div>
            </div>
            <div *ngIf="isFieldInvalid('tickets')" class="text-danger small mt-1">
              Veuillez sélectionner au moins une option
            </div>
          </div>
        </div>

        <!-- Sinon (radio + catégories) -->
        <div class="row" *ngIf="!isCompany">
          <div class="col-md-12 mb-4">
            <label class="fw-bold">Catégorie *</label>
            <div class="row">
              <div class="col-3 input" *ngFor="let option of categorieOptions">
                <label class="d-flex align-items-center gap-2">
                  <input 
                    type="radio" 
                    name="category"
                    [value]="option.id"
                    (change)="onSelectionChange($event, option)" 
                    formControlName="category"
                  />
                  {{ option.label }}
                </label>
              </div>
            </div>
            <div *ngIf="isFieldInvalid('category')" class="text-danger small mt-1">
              Veuillez sélectionner une catégorie
            </div>
          </div>
        </div>

        <!-- Next button -->
        <button
          type="button"
          class="btn w-100 mt-3"
          [disabled]="!isStep1Valid()"
          (click)="goToNextStep()"
        >
          SUIVANT
        </button>
      </div>

      <!-- Step 2: prenom, nom, email, role, password, password confirm -->
      <div *ngIf="currentStep === 2">
        <!-- Prénom / Nom -->
        <div class="row">
          <div class="col-md-6 mb-4" *ngFor="let field of ['ownerFirstName', 'ownerLastName']">
            <div class="form-outline">
              <label class="form-label" [for]="field">{{ field === 'ownerFirstName' ? 'Prénom contact *' : 'Nom contact *' }}</label>
              <input 
                type="text" 
                [id]="field" 
                class="form-control form-control-lg input"
                [formControlName]="field"
              />
              <div *ngIf="isFieldInvalid(field)" class="text-danger small mt-1">
                Ce champ est requis
              </div>
            </div>
          </div>
        </div>

        <!-- Email -->
        <div class="form-outline mb-4">
          <label class="form-label" for="ownerEmail">Adresse email *</label>
          <input
            type="text"
            id="ownerEmail"
            class="form-control form-control-lg input"
            formControlName="ownerEmail"
          />
          <div *ngIf="isFieldInvalid('ownerEmail')" class="text-danger small mt-1">
            Ce champ est requis
          </div>
        </div>

        <!-- Rôle (uniquement pour isCompany) -->
        <div class="form-outline mb-4" *ngIf="isCompany">
          <label class="form-label" for="role">Votre rôle / Poste *</label>
          <select id="role" class="form-control form-control-lg input" formControlName="role">
            <option value="" disabled selected>Sélectionnez votre rôle</option>
            <option *ngFor="let role of ['DG', 'DAF', 'DRH', 'Manager', 'Gerant']" [value]="role">
              {{ role }}
            </option>
          </select>
          <div *ngIf="isFieldInvalid('role')" class="text-danger small mt-1">
            Veuillez sélectionner votre rôle
          </div>
        </div>

        <!-- Mot de passe -->
        <div class="form-outline mb-4" *ngFor="let field of ['password', 'passwordConfirm']">
          <label class="form-label" [for]="field">
            {{ field === 'password' ? 'Mot de passe *' : 'Confirmation du mot de passe *' }}
          </label>
          <input 
            type="password" 
            [id]="field" 
            class="form-control form-control-lg input"
            [formControlName]="field"
          />
          <div *ngIf="isFieldInvalid(field)" class="text-danger small mt-1">
            Ce champ est requis
          </div>
          <div *ngIf="field === 'passwordConfirm' && passwordMismatch()" class="text-danger small mt-1">
            Les mots de passe ne correspondent pas
          </div>
        </div>

        <!-- Navigation buttons -->
        <div class="d-flex justify-content-between mt-3">
          <button type="button" class="btn btn-outline-secondary w-25" (click)="goToPreviousStep()">
            RETOUR
          </button>
          <button
            type="submit"
            class="btn w-70"
            [disabled]="!(isCompany ? signupForm.valid : signupFormMerchant.valid) || passwordMismatch()"
            (click)="onSubmit()"
          >
            CRÉER MON COMPTE
          </button>
        </div>
      </div>
    </form>
  </div>
  <div class="card flex justify-content-center">
    <p-toast />
  </div>
</div>
